import { Divider, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { AsyncSelect, ControlledTextField } from "src/components/forms";
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';
import { OperacionADLFields } from "../types/fields";
import { OpcionSiNo, useSiNoOptions } from "../../adcm/hooks/useOpcionesGenericas";

interface SeccionNuevoADLDetalleTransaccionProps {
  formMethods: UseFormReturn<any>
}

export const SeccionNuevoADLDetalleTransaccion = ({ formMethods }: SeccionNuevoADLDetalleTransaccionProps) => {
  const { control, setValue, trigger } = formMethods;
  const loadSiNo = useSiNoOptions();
  
  const watchedGarantias = useWatch({ control, name: OperacionADLFields.Garantias });
  const watchedPrecancelable = useWatch({ control, name: OperacionADLFields.Precancelable });

  // limpieza de cmapos condicionales
  useEffect(() => {
    if (watchedGarantias === false) {
      setValue(OperacionADLFields.DetalleGarantias, '');
      setValue(OperacionADLFields.DetalleAforo, '');
    }
    if (watchedGarantias === true) {
        trigger([OperacionADLFields.DetalleGarantias, OperacionADLFields.DetalleAforo]);
    }
  }, [watchedGarantias, setValue, trigger]);

  useEffect(() => {
    if (watchedPrecancelable === false) {
      setValue(OperacionADLFields.CondicionesPrecancelacion, null);
    }
    if (watchedPrecancelable === true) {
        trigger(OperacionADLFields.CondicionesPrecancelacion);
    }
  }, [watchedPrecancelable, setValue, trigger]);

  return (
    <CardActions title='Detalle de la Transacción' icon='mdi:swap-horizontal' colapsable>
      <Grid container spacing={2.5}>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12}>
              <ControlledTextField label='Entidad Puente acreedora' name={OperacionADLFields.EntidadPuenteAcreedora} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Moneda' name={OperacionADLFields.Moneda} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Monto' name={OperacionADLFields.Monto} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Comisión estructuración' name={OperacionADLFields.ComisionEstructuracion} control={control} fullWidth />
            </Grid>
          </SectionBox>
        </Grid>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12}>
              <ControlledTextField label='Tasa de interés' name={OperacionADLFields.TasaInteres} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Plazo' name={OperacionADLFields.Plazo} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Tipo de amortización de capital' name={OperacionADLFields.TipoAmortizacionCapital} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Frecuencia de pago de interes' name={OperacionADLFields.FrecuenciaPagoInteres} control={control} fullWidth />
            </Grid>
          </SectionBox>
        </Grid>

        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Garantías
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12} md={4}>
              <AsyncSelect
                label='Garantías'
                name={OperacionADLFields.Garantias}
                loadOptions={loadSiNo}
                control={control}
                fullWidth
                selectNotNulleable
              />
            </Grid>
            {watchedGarantias === OpcionSiNo.Si && (
              <>
                <Grid item xs={12}>
                  <ControlledTextField label='Detalle garantías' name={OperacionADLFields.DetalleGarantias} control={control} fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <ControlledTextField label='Detalle aforo' name={OperacionADLFields.DetalleAforo} control={control} fullWidth />
                </Grid>
              </>
            )}
          </SectionBox>
        </Grid>

        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Precancelación
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12} md={4}>
              <AsyncSelect
                label='Precancelable'
                name={OperacionADLFields.Precancelable}
                loadOptions={loadSiNo}
                control={control}
                fullWidth
                selectNotNulleable
              />
            </Grid>
            {watchedPrecancelable === OpcionSiNo.Si && (
              <Grid item xs={12} md={4}>
                <ControlledTextField
                  label='Condiciones de precancelación'
                  name={OperacionADLFields.CondicionesPrecancelacion}
                  control={control}
                  fullWidth
                />
              </Grid>
            )}
          </SectionBox>
        </Grid>

      </Grid>
    </CardActions>
  );
};
